import React, {useContext, useEffect, useState} from 'react';
import {Modal, StyleSheet, Text, TouchableOpacity, useWindowDimensions, ScrollView, View, Image} from 'react-native';
import {colors} from '../assets/styles/colors';
import {StoreContext} from '../components/StoreContextProvider';
import {focus_plus_icon} from '../constants/assest-manager';
import PayTable from "../components/PayTable";
import {tabletBreakpoint} from "../constants";
import DistanceChallengeItem from "../components/DistanceChallengeItem";
import MainStyle from "../../MainStyle";
import location from "../assets/img/location_icon.png";
import Div from "../lib/Div";

const ContestEntryModal = () => {
  const {contestEntryModalConfig} = useContext(StoreContext);
  const {visible, amount, contestAmount, largestDistanceChallenge, challengesList} = contestEntryModalConfig;
  const {payLinesList, holeInOneAmount} = contestEntryModalConfig;
  const {width} = useWindowDimensions();
  const isMd = width >= tabletBreakpoint;
  const [challengeId, setChallengeId] = useState<bigint>();

  useEffect(() => {
    if (contestEntryModalConfig.challengeId) {
      setChallengeId(typeof contestEntryModalConfig.challengeId === 'bigint' ? contestEntryModalConfig.challengeId : BigInt(contestEntryModalConfig.challengeId))
    }
  }, [visible]);

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={contestEntryModalConfig?.onCancel}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_darkOverlay]}>
        <ScrollView contentContainerStyle={[MainStyle.full_h, MainStyle.full_w]}>
          <Div minH="100%" justifyContent="center" alignItems="center" px={40} py={104}>
            <Div position="relative" maxW={isMd ? 500 : 280} w="100%">
              <Div w="100%" bg={colors.deepBlue} borderWidth={1} borderColor={colors.lightBlue} rounded={4}
                   overflow="hidden">
                <Div h={32} bg={colors.blueText} row justifyContent="center" alignItems="center" position="relative">
                  <Div h="100%" row justifyContent="center" alignItems="center" position="absolute" left={0} p={10}
                       top={0}>
                    <Image
                      resizeMode="contain" style={[MainStyle.w_24, MainStyle.h_24]}
                      source={challengesList?.length ? focus_plus_icon : location}
                    />
                  </Div>

                  <Text style={[styles.title, {fontSize: 14}]}>
                    {challengesList?.length ? 'CLOSEST TO THE PIN' : 'CHOOSE CHALLENGE'}
                  </Text>
                </Div>

                {challengesList?.length ? (
                  <Div pt={49} px={15} pb={47} flexDir="column" alignItems="center">
                    <Div w="100%" mb={34}>
                      <DistanceChallengeItem
                        label="DISTANCE:"
                        value={`${largestDistanceChallenge ? Number(largestDistanceChallenge.value1) / 36 : 0} YARDS`}
                        dense={false}
                        w="100%"
                        mb={4}
                      />

                      <DistanceChallengeItem
                        label="WIN CIRCLE:"
                        value={`${largestDistanceChallenge ? Number(largestDistanceChallenge.value2) / 12 : 0} FEET`}
                        dense={false}
                        w="100%"
                        mb={4}
                      />

                      <DistanceChallengeItem
                        label="CHALLENGE FEE:"
                        value={`$${contestAmount}`}
                        dense={false}
                        w="100%"
                      />
                    </Div>
                    <Div w="100%">
                      <PayTable
                        payLinesList={payLinesList}
                        challengesList={challengesList}
                        amount={amount}
                        holeInOneAmount={holeInOneAmount}
                      />
                    </Div>
                  </Div>
                ) : null}
              </Div>

              <Div flexDir="column-reverse" bottom={-104} left={16} right={16} justifyContent="space-between"
                   position="absolute">
                <TouchableOpacity style={styles.outline_btn_s} onPress={contestEntryModalConfig.onCancel}>
                  <Text style={[styles.outlineBtnText, {fontSize: 16}]}>CANCEL CHALLENGE</Text>
                </TouchableOpacity>
                <TouchableOpacity style={styles.fill_btn_s}
                                  onPress={() => contestEntryModalConfig.onOk ? contestEntryModalConfig.onOk(challengeId) : null}>
                  <Text style={[styles.fillBtnText, {fontSize: 16}]}>CONFIRM CHALLENGE ENTRY</Text>
                </TouchableOpacity>
              </Div>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  title: {fontWeight: '700', color: '#F5F5F5'},
  fill_btn_s: {
    backgroundColor: '#209D01', borderWidth: 1, borderColor: 'rgba(0, 0, 0, 0.5)', borderStyle: 'solid', height: 40,
    borderRadius: 28, marginBottom: 9, justifyContent: 'center'
  },
  fillBtnText: {fontWeight: '700', textAlign: 'center', color: '#F5F5F5'},
  outline_btn_s: {
    height: 40, backgroundColor: '#07111C', borderWidth: 1, borderColor: '#FF6262', borderStyle: 'solid',
    borderRadius: 28, justifyContent: 'center'
  },
  outlineBtnText: {fontWeight: '700', textAlign: 'center', color: '#FF6262'}
});

export default ContestEntryModal;
